var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "linkedin_1_",
    "data-name": "linkedin (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(7.396 6.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M43.5,33.6v6.077H39.979V34c0-1.424-.509-2.4-1.784-2.4A1.927,1.927,0,0,0,36.388,32.9a2.411,2.411,0,0,0-.117.859v5.918H32.748s.047-9.6,0-10.6h3.524v1.5c-.007.012-.017.023-.023.035h.023v-.035a3.5,3.5,0,0,1,3.175-1.75c2.318,0,4.056,1.515,4.056,4.769ZM29.062,23.969a1.836,1.836,0,1,0-.046,3.662h.023a1.837,1.837,0,1,0,.023-3.662Zm-1.784,15.7H30.8v-10.6H27.277Z",
    transform: "translate(-27.068 -23.969)",
    fill: "#210321"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinicon);
export default __webpack_public_path__ + "static/media/linkedin icon .fbee1650308786fe103debcb0c8f79ac.svg";
export { ForwardRef as ReactComponent };